import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export function createRouter() {
    return new Router({
        mode: 'history', // 'hash',
        fallback: false,
        scrollBehavior: () => ({ y: 0 }),
        routes: [
            {
                path: '/privacy',
                component: () => import('../views/privacy/index.vue')
            },
            {
                path: '/leads',
                component: () => import('../views/leads/index.vue')
            },
            {
                path: '/driver',
                component: () => import('../views/driver/index.vue')
            },
            {
                path: '/at-driver',
                component: () => import('../views/driver/at.vue')
            },
            {
                path: '/marketing/:lpid',
                component: () => import('../views/marketing/index.vue')
            },
            {
                path: '/guide/:gpid',
                component: () => import('../views/marketing/guide.vue')
            },
            {
                path: '/orderinfo',
                component: () => import('../views/driver/order-info.vue')
            },
            {
                path: '/orders',
                component: () => import('../views/orders/index.vue')
            },
            {
                path: '/orders/:order_no',
                component: () => import('../views/orders/detail.vue')
            },
            {
                path: '/notice',
                component: () => import('../views/driver/notice.vue')
            },
            {
                path: '/invite-records',
                component: () => import('../views/driver/invite-records.vue')
            },
            {
                path: '/f/qr',
                component: () => import('../views/error/qr.vue')
            },
            {
                path: '/evaluations',
                component: () => import('../views/evaluations/index.vue')
            },
            {
                path: '/esign',
                component: () => import('../views/esign/index.vue')
            },
            {
                path: '/esign/success',
                component: () => import('../views/esign/success.vue')
            },
            {
                path: '/report/fellow',
                component: () => import('../views/report/fellow.vue')
            },
            {
                path: '/error',
                component: () => import('../views/error/index.vue')
            }
        ]
    });
}



// WEBPACK FOOTER //
// ./src/router/index.js